import { MarketingDismissResponseDTO, MarketingOptInResponseDTO } from '@hexcrawl/shared-utils';
import api from './api';

export const marketingService = {
  /**
   * Record marketing consent. `email` is only consulted for accounts with no address on file — where
   * one exists the server uses it and ignores this. The server also derives the recorded source, so
   * the client cannot misattribute a signup.
   */
  async optIn(email?: string): Promise<MarketingOptInResponseDTO> {
    const response = await api.post<MarketingOptInResponseDTO>('/marketing/opt-in', { email });
    return response.data;
  },

  /**
   * Record that the player declined, so the prompt stops appearing. Persisted server-side rather
   * than in client state, so a refusal survives a new session or a different device.
   */
  async dismissPrompt(): Promise<MarketingDismissResponseDTO> {
    const response = await api.post<MarketingDismissResponseDTO>('/marketing/dismiss', {});
    return response.data;
  },
};
